/**
 * Maps Firebase and other technical error codes/messages to user-friendly messages.
 */

const FIREBASE_AUTH_ERRORS: Record<string, string> = {
  "auth/email-already-in-use": "This email is already registered. Try logging in instead.",
  "auth/invalid-email": "Please enter a valid email address.",
  "auth/user-disabled": "This account has been disabled. Contact support for help.",
  "auth/user-not-found": "No account found with this email.",
  "auth/wrong-password": "Incorrect password. Please try again.",
  "auth/invalid-credential": "Incorrect email or password. Please try again.",
  "auth/too-many-requests": "Too many attempts. Please wait a moment and try again.",
  "auth/weak-password": "Password is too weak. Use at least 6 characters.",
  "auth/network-request-failed": "Network error. Check your connection and try again.",
  "auth/popup-closed-by-user": "",
  "auth/account-exists-with-different-credential":
    "An account already exists with this email using a different sign-in method.",
  "auth/requires-recent-login": "Please log out and log in again to perform this action.",
  "auth/operation-not-allowed": "This sign-in method is not enabled.",
  "auth/expired-action-code": "This link has expired. Please request a new one.",
  "auth/invalid-action-code": "This link is invalid or has already been used.",
};

/**
 * Extracts a user-friendly message from a Firebase error or generic Error.
 * Falls back to the provided fallback message if no mapping is found.
 */
export function getErrorMessage(error: unknown, fallback: string): string {
  if (!error || typeof error !== "object") return fallback;

  const err = error as { code?: string; message?: string };

  // Try Firebase error code first
  if (err.code && err.code in FIREBASE_AUTH_ERRORS) {
    return FIREBASE_AUTH_ERRORS[err.code] || fallback;
  }

  // If the message looks like a raw Firebase error, don't show it
  if (err.message && /^Firebase:/.test(err.message)) {
    return fallback;
  }

  return fallback;
}
